import React, { useContext } from 'react';
import classes from './BulkImportNavigationTabs.module.scss';
import { IconsEnum } from '../../../constants/icons';
import classNames from 'classnames';
import { MandatoryChildren } from '../../../models/children-props';
import { Icon } from '../../../components/images/Icon/Icon';
import { BulkActionsState } from '../../../models/bulk-actions';
import { BulkActionsContext } from '../states/BulkActionsProvider';

export type BulkImportNavigationTabsViewProps = MandatoryChildren<{
  //
  section: keyof BulkActionsState;
  icon: IconsEnum;
  selected: boolean;
  action: VoidFunction;
}>;

export const BulkImportNavigationTabsView = (props: BulkImportNavigationTabsViewProps): JSX.Element => {
  const { action, children, icon, selected, section } = props;
  const { state } = useContext(BulkActionsContext);
  const { hasChanges } = state[section];
  const wrapperClasses = classNames(
    classes.BulkImportNavigationTabs,
    selected ? classes.BulkImportNavigationTabsSelected : ''
  );
  return (
    <a className={wrapperClasses} onClick={() => action()}>
      <div className={classNames('grid-x align-justify align-middle', classes.BulkImportTab)}>
        <div className={'cell shrink'}>
          <div className={'grid-x align-left'}>
            <div className={classNames('cell', 'shrink', classes.Icon, selected ? classes.IconSelected : '')}>
              <Icon name={icon} size={'medium'} />
            </div>
            <div className={'cell shrink'}>{children}</div>
          </div>
        </div>
        {hasChanges ? (
          <div className={'cell shrink'}>
            <div className={classes.BulkImportTabSelected}>
              <span className={'show-for-sr'}>selected</span>
            </div>
          </div>
        ) : null}
      </div>
    </a>
  );
};
